export default __webpack_public_path__ + "39d9a38bbf45b5de8c26585627fb8cde.webp";